<template>
  <div class="report-wrap tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-radio-group v-model="formSearch.reportType" @change="onTypeChange">
          <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.runLog_device_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="onExport"
            :disabled="exporting"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item
          style="float: right; "
          v-if="funcView.runLog_device_export&&formSearch.reportType === 3"
        >
          <el-button
            style="vertical-align: top;"
            @click="onExportMonth"
            :disabled="exportingMonth"
            class="export-month"
          >
            <i class="icon icon-daochu"></i>
            {{ $t('report_location_log.dao_chu_ming_xi') }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('report_location_log.xiang_mu_ming_cheng')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
           :auto="false"
            url="organCsCoList"
            v-model="formSearch.orgId"
            :props="{ label: 'codeName', value: 'orgId' }"
            :placeholder="$t('report_location_log.gong_si_ming_cheng')"
            width="260px"
            @change="onPageChange({ page: 1 })"
            filterable
            remote
            :listener="`${formSearch.orgType || null}${true}`"
            :params="{ num: 50,orgType:formSearch.orgType }"
          ></custom-select>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            v-model="formSearch.orgType"
            code="bas_org_type"
          ></custom-select>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onTypeChange"
      @clear="onClear"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 时间 -->
        <el-form-item :label="$t('Common.com_time')" class="select-date">
          <!-- 天 -->
          <custom-date-picker
            v-show="formSearch.reportType === 0"
            v-model="dateTimes"
            type="daterange"
            align="right"
            unlink-panels
            :start-placeholder="$t('report_location_log.kai_shi_ri')"
            :end-placeholder="$t('report_location_log.jie_shu_ri')"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsIntervalMonthReport"
            :clearable="false"
          ></custom-date-picker>
          <!-- 历史报表 -->
          <!-- 年 -->
          <year-picker
            v-show="formSearch.reportType === 1"
            v-model="reportYearTime"
            class="year-picker"
          ></year-picker>
          <!-- 季度 -->
          <season-picker
            v-show="formSearch.reportType === 2"
            v-model="reportSeasonTime"
            ref="jidupicker"
            class="season-picker"
          >
          </season-picker>
          <!-- 月 -->
          <custom-date-picker
            v-show="formSearch.reportType === 3"
            v-model="reportMonthTime"
            type="monthrange"
            range-separator="—"
            format="yyyy-MM"
            value-format="yyyy-MM"
            align="right"
            placeholder=""
            :picker-options="pickerOptionsIntervalThreeYears"
            prefix-icon="icon icon-calendar"
            :clearable="false"
            :start-placeholder="$t('report_location_log.kai_shi_yue')"
            :end-placeholder="$t('report_location_log.jie_shu_yue')"
          ></custom-date-picker>
          <!--周 -->
          <week-picker
            v-show="formSearch.reportType === 4"
            v-model="reportWeekTime"
            class="week-picker"
          ></week-picker>
        </el-form-item>
        <el-form-item :label="$t('report_location_log.bu_men')">
          <custom-select
            url="DepartmentTree"
            v-model="formSearch.departmentId"
            :model="formSearch"
            :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
            :params="{ isCountDevice:1,orgId:formSearch.orgId?formSearch.orgId:orgId }"
            :listener="`${formSearch.orgId}${orgId}`"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
            ref="tag"
            type="tree"
            filterable
            :dataFilter="departmentTreeFilter"
            @treeValChange="onPageChange({ page: 1 })"
            @treeValChangeLabel="onDepartmentLabel"
            @getList="onDepartmentList"
            clearable
          ></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <!-- {{ tableList }} -->
      <custom-table
        v-if="formSearch.reportType === 0 && isInch"
        tableCode="location_log_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['cleanScore','totalCleanArea', 'goalArea', 'avgCleanArea']"
        @sort="sortChange"
        @filter="filterChange"
      >
        <!--
          cleanScore
          totalCleanArea
          goalArea
          avgCleanArea
        -->
        <template v-slot:cleanScore="scope">
          <span :style="getCleanScoreColor(scope.row.cleanScore)">{{scope.row.cleanScore}}</span>
        </template>
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:goalArea="scope">
          <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
        </template>
        <template v-slot:avgCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.avgCleanArea)}}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType === 0 && !isInch"
        tableCode="location_log "
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['cleanScore']"
      >
        <template v-slot:cleanScore="scope">
          <span :style="getCleanScoreColor(scope.row.cleanScore)">{{scope.row.cleanScore}}</span>
        </template>
      </custom-table>
      <custom-table v-if="formSearch.reportType !== 0 && isInch" tableCode="location_log_date_ft" :stripe="true" @column="setColumn" height="100%" :index="true" :data="tableList" @sort="sortChange" @filter="filterChange"
      :slots="['totalCleanArea','avgCleanArea','actualCleanArea','attendanceRate']">

        <!--
          totalCleanArea
          avgCleanArea
          actualCleanArea
          attendanceRate
        -->
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:avgCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.avgCleanArea)}}</span>
        </template>
        <template v-slot:actualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.actualCleanArea)}}</span>
        </template>
        <template v-slot:attendanceRate="scope">
           <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
      </custom-table>
      <custom-table v-if="formSearch.reportType !== 0 && !isInch" tableCode="location_log_date" :stripe="true" @column="setColumn" height="100%" :index="true" :data="tableList" @sort="sortChange" @filter="filterChange"
      :slots="['attendanceRate']"
      >
        <template v-slot:attendanceRate="scope">
           <span :style="getCleanScoreColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
    </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'report',
  mixins: [resetFormSearchMixins],
  components: {
    seasonPicker,
    yearPicker,
    weekPicker,
  },
  computed: {
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    },
    reportTypeData() {
      return [
        {
          label: this.$t('report_location_log.ri'),
          value: 0,
        },
        {
          label: this.$t('report_location_log.zhou'),
          value: 4,
        },
        {
          label: this.$t('report_location_log.yue'),
          value: 3,
        },
        {
          label: this.$t('report_location_log.ji'),
          value: 2,
        },
        {
          label: this.$t('report_location_log.nian'),
          value: 1,
        },
      ];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
    // 选择日期配置
    pickerOptionDisAfter() {
      return {
        shortcuts: [
          {
            text: this.$t('Common.com_last_week'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_month'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_three_months'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      };
    },
  },
  data() {
    return {
      provide: true,
      formSearch: {
        orgType: '',
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        bodyNum: '',
        productCode: '',
        productName: '',
        locationId: '',
        locationName: '',
        // region: '',
        locationAddress: '',
        afterServiceName: '',
        customerName: '',
        agentCoName: '',

        beginReportDate: '',
        endReportDate: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        tagName: '',
        siteName: '',
        orgId: '',
        departmentId: ''
      },
      tagId: '',
      tags: [],
      // 日
      dateTimes: [this.$momentWorld(moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))],
      reportYearTime: [`${moment(this.$getLocalTime()).year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [`${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`, `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`],
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`],
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week())), this.$momentElLocal(moment().week(moment().week()))],
      tableList: [],
      totalRows: 0,


      link: null,
      exporting: false,
      exportingMonth: false,
    };
  },

  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    // this.formSearch.beginReportDate = this.dateTimes ? this.dateTimes[0] : '';
    // this.formSearch.endReportDate = this.dateTimes ? this.dateTimes[1] : '';
    // 设置orgType默认值为bizType
    this.formSearch.orgType = this.bizType;

    this.onTypeChange();
  },
  methods: {
    // 获取列表
    getTableList() {
      if (this.formSearch.reportType === 0) {
        this.$getJSON(apis.ReportDailyLocationPage, { ...this.formSearch,
          orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
          // 字段改了要用startDate endDate传时间 天的格式
          startDate: this.$momentElLocal(this.formSearch.beginReportDate, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endReportDate, 'YYYY-MM-DD'),
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          multiple: ''
        })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isMeetGoal', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      } else {
        this.$getJSON(apis.LocationDevicePage, { ...this.formSearch,
          beginReportDate: this.formSearch.beginReportDate.replace(/-/g, ''),
          endReportDate: this.formSearch.endReportDate.replace(/-/g, ''),
          orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          multiple: ''
        })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isMeetGoal', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    onTypeChange() {
      switch (this.formSearch.reportType) {
        case 1:
          this.formSearch.beginReportDate = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endReportDate = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 2:
          this.formSearch.beginReportDate = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endReportDate = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 3:
          this.formSearch.beginReportDate = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endReportDate = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 4:
          // 设置周的开始时间是星期一 1月1号是年开始的第一周
          moment.updateLocale('en', {
            week: {
              // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
              dow: 1, // Monday is the first day of the week.
              doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
            },
          });
          this.formSearch.beginReportDate = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endReportDate = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.onPageChange({ page: 1 });
          break;
        default:
          // 天  由于没有用init-value的默认设置方式  传参要转成世界时间
          this.formSearch.beginReportDate = this.dateTimes ? this.dateTimes[0] : '';
          this.formSearch.endReportDate = this.dateTimes ? this.dateTimes[1] : '';
          this.onPageChange({ page: 1 });
      }
    },
    onClear() {
      this.formSearch.bodyNum = '';
      this.formSearch.productCode = '';
      this.formSearch.productName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      this.formSearch.region = '';
      this.formSearch.locationAddress = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.customerName = '';
      this.formSearch.agentCoName = '';
      this.formSearch.beginReportDate = '';
      this.formSearch.endReportDate = '';
      this.formSearch.countryCode = '';
      this.formSearch.provinceCode = '';
      this.formSearch.cityCode = '';
      this.formSearch.tagName = '';
      this.formSearch.siteName = '';
      this.formSearch.departmentId = '';
      this.dateTimes = [this.$momentWorld(moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))];
      // this.formSearch.beginReportDate = this.dateTimes ? this.dateTimes[0] : '';
      // this.formSearch.endReportDate = this.dateTimes ? this.dateTimes[1] : '';
      // this.reportYearTime = [];
      // this.reportSeasonTime = [];
      // this.reportMonthTime = [];
      // this.reportWeekTime = [];

      this.onTypeChange();
    },
    // 获取标列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },


    onExport: function () {
      this.exporting = true;
      if (this.formSearch.reportType === 0) {
        this.exportTable('ReportDailyLocationExport', { ...this.formSearch,
          // 字段改了要用startDate endDate传时间 天的格式
          startDate: this.$momentElLocal(this.formSearch.beginReportDate, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endReportDate, 'YYYY-MM-DD'),
          orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          multiple: '',
          platform: 'isynergy'
        }).then(() => {
          this.exporting = false;
        }).catch(() => {
          this.exporting = false;
        });
      } else {
        this.exportTable('LocationDeviceExport', { ...this.formSearch,
          beginReportDate: this.formSearch.beginReportDate.replace(/-/g, ''),
          endReportDate: this.formSearch.endReportDate.replace(/-/g, ''),
          orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
          departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
          multiple: '',
          platform: 'isynergy' }).then(() => {
          this.exporting = false;
        }).catch(() => {
          this.exporting = false;
        });
      }
    },
    onExportMonth() {
      this.exportingMonth = true;
      this.exportTable('LocationDeviceMonthDetailExport', { ...this.formSearch,
        beginReportDate: this.formSearch.beginReportDate.replace(/-/g, ''),
        endReportDate: this.formSearch.endReportDate.replace(/-/g, ''),
        orgId: this.formSearch.orgId ? this.formSearch.orgId : this.orgId,
        departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '',
        multiple: '',
        platform: 'isynergy' }).then(() => {
        this.exportingMonth = false;
      }).catch(() => {
        this.exportingMonth = false;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },
    getCleanScoreColor(rate) {
    // 提取百分比值中的数字部分
      const value = parseFloat(rate);
      if (typeof value !== 'number') {
        return {};
      }
      // 根据条件返回不同的颜色样式
      if (value >= 90) {
        return { color: '#4CAF50' }; // 绿色
      } else if (value >= 70 && value < 90) {
        return { color: '#FFC107' }; // 黄色
      } else {
        return { color: '#F44336' }; // 红色
      }
    },

    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.departmentName = Label;
    },
  },
};
</script>

<style lang="scss">
.report-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: hidden;
  .export-month{
     color: rgba(13, 154, 224, 1);
  }
}

</style>
